<template>
  <app-page-title
    class='_ptxs _pbxs'
    >
    <template #pageTitleLeft>
      <h1 class='color-lips'>
        <font-awesome-icon :icon='memberEditIcon' class='_mrxs' aria-hidden="true" role="presentation"/>
        {{memberDetails.member.firstName}} {{memberDetails.member.lastName}}
        <slot></slot>

        <strong v-if="subtitle"> / {{subtitle}}</strong>
      </h1>
    </template>
    <template #pageTitleRight>
      <page-actions
        :cancelRoute="cancelRoute"
        :submitEnabled="submitEnabled"
        :isSubmitting="isSubmitting"
        :savingDraft="savingDraft"
        @submit="$emit('submit')"
        @saveDraft="$emit('saveDraft')"
        />
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@organisms/PageTitle'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import PageActions from './PageActions'
  import memberManagement from '@mixins/memberManagement'

  export default {
    mixins: [memberManagement],
    components: {
      AppPageTitle,
      FontAwesomeIcon,
      PageActions
    },
    props: {
      subtitle: String,
      cancelRoute: {
        type: Object,
        default() {
          return {
            name: 'member-management'
          }
        }
      },
      submitEnabled: {
        type: Boolean,
        default: true
      },
      savingDraft: {
        type: Boolean,
        default: false
      },
      isSubmitting: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      memberEditIcon () {
        return this.memberLocked ? 'lock' : 'edit'
      }
    }
  }
</script>
